import React from 'react';
import { useSelector } from 'react-redux';

import CreditCardDetails from './CreditCard';
import PayPalDetails from './PayPal';

export default function PaymentDetails() {
  const { selected } = useSelector((state) => state.paymentMethods);
  const { step } = useSelector((state) => state.step);

  if (step !== 4) {
    return null;
  }

  switch (selected) {
    case 1:
      return <CreditCardDetails />;
    case 2:
      return <PayPalDetails />;
    default:
      return null;
  }
}
